import BpkModal from '@skyscanner/backpack-web/bpk-component-modal';

import DestinationSelector from '../DestinationSelector';

import type { AutosuggestSuggestionsOrPopularDestinations } from '../../../types';
import type { Maybe } from '@shared/types/utils';
import type { Destination } from '@shared/ui/types';

import { HASH_LOCATION_MODAL } from '@shared/constants/hash-routes';
import HashRoute from '@shared/ui/common/HashRoute';
import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';

type Props = {
  destinationLabel: string;
  destination?: Destination;
  arrangeInline?: boolean;
  valid?: Maybe<boolean>;
  className?: Maybe<string>;
  onSuggestionSelected: Function;
  onSuggestionsFetchRequested: Function;
  onSuggestionsClearRequested: Function;
  suggestions: AutosuggestSuggestionsOrPopularDestinations;
  cancelLabel: string;
  onChangeInputValue?: Maybe<Function>;
};

const DestinationSelectorModal = ({
  arrangeInline,
  cancelLabel,
  className,
  destination,
  destinationLabel,
  onChangeInputValue,
  onSuggestionSelected,
  onSuggestionsClearRequested,
  onSuggestionsFetchRequested,
  suggestions,
  valid,
}: Props) => (
  <HashRoute
    hash={HASH_LOCATION_MODAL}
    render={({ onClose }: any) => (
      <BpkModal
        id="hotel-destination-modal"
        isOpen
        onClose={onClose}
        title={destinationLabel}
        closeText={cancelLabel}
        getApplicationElement={getApplicationElement}
        closeOnEscPressed
      >
        <DestinationSelector
          className={className}
          destination={destination}
          lightLabel={false}
          hideLabel
          onSuggestionSelected={(
            item: AutosuggestSuggestionsOrPopularDestinations,
          ) => {
            onClose();
            onSuggestionSelected(item);
          }}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          suggestions={suggestions}
          arrangeInline={arrangeInline}
          isMobile
          onChangeInputValue={onChangeInputValue}
          valid={valid}
        />
      </BpkModal>
    )}
  />
);

export default DestinationSelectorModal;
